import { Props } from "./types";
import Image from "next/image";

const FormHeader = ({ title, subtitle, image, className, explanation }: Props): JSX.Element => {
  return (
    <h1
      className={`flex flex-col items-center mb-8 text-4xl font-bold md:mb-16 md:flex-row ${className}`}
    >
      <div className="relative w-16 h-16 min-w-[4rem] min-h-[4rem] mb-4 md:mb-0">
        <Image src={image} alt={subtitle || title} objectFit="contain" layout="fill" />
      </div>

      <div className="max-w-full mx-3 text-3xl leading-10 text-center md:text-4xl md:text-left ">
        {title}

        {subtitle && (
          <>
            <br />
            <div className="text-brown-500 break-words">{subtitle}</div>
          </>
        )}
        {explanation && (
          <>
            <br />
            <div className="font-serif text-3xl break-words font-normal">{explanation}</div>
          </>
        )}
      </div>
    </h1>
  );
};

export default FormHeader;
